/**
 * Handles switching between the different popup galleries.
 *
 * @export
 * @class Gallery
 */
import { BaseModule } from '../../helpers/base_module';
import { getAll } from '../../helpers/utilities';

import { GalleryPopup } from './gallery-popup';

export class Gallery extends BaseModule {
    private popups: GalleryPopup[] = [];
    private currentPopup!: GalleryPopup;

    /**
     * Creates an instance of Gallery.
     * 
     * @memberof Gallery
     */
    constructor() {
        super();
        super.makePublic('application_galleries');
        this.popups = this.getPopups();
        this.bindEvents();
    }


    private bindEvents(): void {

        document.addEventListener('click', (event) => {
            const target = event.target as HTMLElement;

            // Prev gallery
            if(target.classList.contains('.js-popup-gallery__prev') || target.closest('.js-popup-gallery__prev')) {
                this.prev();
            }

            // Next gallery
            if(target.classList.contains('.js-popup-gallery__next') || target.closest('.js-popup-gallery__next')) {
                this.next();
            }
        });

    }


    /**
     * Goes to the next popup
     *
     * @public
     * @memberof Gallery
     */
    public next(): void {
        this.currentPopup.close();
        const currentIndex = this.popups.indexOf(this.currentPopup);
        const nextItem = this.popups[currentIndex + 1] ? this.popups[currentIndex + 1] : this.popups[0];
        nextItem.open();
    }


    /**
     * Goes to the next popup
     *
     * @public
     * @memberof Gallery
     */
    public prev(): void {
        this.currentPopup.close();
        const currentIndex = this.popups.indexOf(this.currentPopup);
        const nextItem = this.popups[currentIndex - 1] ? this.popups[currentIndex - 1] : this.popups[this.popups.length - 1];
        nextItem.open();
    }


    /**
     * Records the provided popup as the active one
     *
     * @param {GalleryPopup} popup The popup to record as active
     * @memberof Gallery
     */
    public setCurrentPopup(popup: GalleryPopup): void {
        this.currentPopup = popup;
    }


    /**
     * Returns an array of gallery popups
     *
     * @private
     * @returns {GalleryPopup[]}
     * @memberof Gallery
     */
    private getPopups(): GalleryPopup[] {
        const popups: GalleryPopup[] = [];
        const items  = getAll('.js-application-gallery') as Element[];
        if(items) {
            items.forEach(item => {
                popups.push(new GalleryPopup(item));
            });
        }
        return popups;
    }
}
